import Vector from "./vector";

export abstract class FixedSizeVector<T extends ArrayBufferView, K> extends Vector<T, K> {}
